import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CourseService {
  public requestAPIurl: any = environment.apiURL;
  public selectedCourse: any;
  public selectedModule: any;
  public selectedLesson: any;
  public userId: any;
  public headers: any;
  public courseMode: any;
  constructor(private http: HttpClient) {

  }


  addCourse(body) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/course/add`, body, { 'headers': this.headers });
  }

  getAllCourses() {
    return this.http.get(`${this.requestAPIurl}/api/course/all`);
  }

  getAllPublishedCourses(body = {}) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/course/published/all`, body, { headers: this.headers });
  }

  getSampleCourses() {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/course/sample`, { headers: this.headers });
  }

  publishCourse() {
    this.setHeaders();
    return this.http.put(`${this.requestAPIurl}/api/course/${this.selectedCourse}/publish`, {}, { headers: this.headers });
  }

  unpublishCourse() {
    this.setHeaders();
    return this.http.put(`${this.requestAPIurl}/api/course/${this.selectedCourse}/unpublish`, {}, { headers: this.headers })
  }

  getCourse(id) {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/course/${id}`, { headers: this.headers });
  }

  updateCourse(body, id) {
    this.setHeaders();
    return this.http.put(`${this.requestAPIurl}/api/course/${id}/modify`, body, { headers: this.headers });
  }

  addModule(body, courseId = this.selectedCourse) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/course/${courseId}/module/add`, body, { 'headers': this.headers })
  }

  getAllModules(id = this.selectedCourse) {
    return this.http.get(`${this.requestAPIurl}/api/course/${id}/module/all`)
  }

  getModule(courseId = this.selectedCourse, moduleId) {
    return this.http.get(`${this.requestAPIurl}/api/course/${this.selectedCourse}/module/${moduleId}`);
  }

  updateModule(body, courseId, moduleId) {
    this.setHeaders();
    return this.http.put(`${this.requestAPIurl}/api/course/${courseId}/module/${moduleId}/modify`, body, { headers: this.headers });
  }

  addLesson(body, courseId, moduleId) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/course/${courseId}/module/${moduleId}/lesson/add`, body, { 'headers': this.headers })
  }

  getAllLessons(courseId = this.selectedCourse, moduleId = this.selectedModule) {
    return this.http.get(`${this.requestAPIurl}/api/course/${courseId}/module/${moduleId}/lesson/all`)
  }

  getLesson(courseId = this.selectedCourse, moduleId = this.selectedModule, lessonId = this.selectedLesson) {
    return this.http.get(`${this.requestAPIurl}/api/course/${courseId}/module/${moduleId}/lesson/${lessonId}`)
  }

  updateLesson(body, courseId, moduleId, lessonId) {
    this.setHeaders();
    return this.http.put(`${this.requestAPIurl}/api/course/${courseId}/module/${moduleId}/lesson/${lessonId}/modify`, body, { headers: this.headers });
  }

  deleteLesson(courseId, moduleId, lessonId) {
    this.setHeaders();
    return this.http.delete(`${this.requestAPIurl}/api/course/${courseId}/module/${moduleId}/lesson/${lessonId}`, { headers: this.headers })
  }

  addToCart(courseId) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/cart/course/${courseId}/add`, {}, { headers: this.headers });
  }

  removeFromCart(courseId) {
    return this.http.delete(`${this.requestAPIurl}/api/cart/course/${courseId}/remove`, { headers: this.headers });
  }

  getCartedCourses() {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/cart`, { headers: this.headers });
  }

  purchaseCourse(courseId, body) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/course/${courseId}/purchase`, body, { headers: this.headers })
  }

  getAllPurchasedCourse() {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/course/purchased/all`, { headers: this.headers });
  }

  addQuiz(body, courseId, moduleId, quizId) {
    this.setHeaders();
    return this.http.put(`${this.requestAPIurl}/api/course/${courseId}/module/${moduleId}/quiz/${quizId}/modify`, body, { headers: this.headers });
  }

  getQuiz(courseId, moduleId, quizId) {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/course/${courseId}/module/${moduleId}/quiz/${quizId}`, { headers: this.headers })
  }

  validateQuiz(courseId, moduleId, quizId, body) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/course/${courseId}/module/${moduleId}/quiz/${quizId}/validate`, body, { headers: this.headers });
  }

  getAllScores() {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/user/${this.userId}/scores/all`, { headers: this.headers })
  }

  restrictOrEnableCourseForUser(userId, courseId, type) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/admin/user/${userId}/course/${courseId}/${type}`, {}, { headers: this.headers });
  }

  topCourses() {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/course/top/6`, { headers: this.headers })
  }

  lastPlayedCourse() {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/course/purchasedCourse/latest`, { headers: this.headers })
  }

  updateLastPlayedCourse(courseId, lessonId = null, moduleId = null, body = null) {
    this.setHeaders();
    if (body == null) {
      body = {
        lastPlayedLesson: lessonId,
        lastPlayedModule: moduleId
      };
    }
    return this.http.put(`${this.requestAPIurl}/api/course/purchasedCourse/${courseId}/update`, body, { headers: this.headers });
  }

  getLatestPlayedVideoOfCourse(courseId) {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/course/purchasedCourse/${courseId}/latest`, { headers: this.headers })
  }

  getCertificate(purchasedCourseId) {
    this.setHeaders();
    return this.http.get(`${this.requestAPIurl}/api/course/${purchasedCourseId}/certificate`, { headers: this.headers });
  }

  setHeaders() {
    if (JSON.parse(sessionStorage.getItem('logged-in-user'))) {
      this.userId = JSON.parse(sessionStorage.getItem('logged-in-user'))._id;
      this.headers = new HttpHeaders().set('id', this.userId);
    }
  }

  payForCourse(body) {
    this.setHeaders();
    return this.http.post(`${this.requestAPIurl}/api/activity/add`, body, { headers: this.headers });
  }

}
